import callCmAPI from 'services/helpers/call-cm-api'
import { Zone, WebApi2Response } from 'types'

/******************
 * Fetch from API *
 ******************/

export const getGlobalZones = (): Promise<WebApi2Response<Zone[]>> =>
  callCmAPI(`/global-data/get-all-zones`, {
    method: 'get',
  })
    .then((res) => {
      return { success: true as const, data: res.data as Zone[] }
    })
    .catch((err) => {
      return {
        success: false as const,
        data: null,
        error: err,
      }
    })
